import { jsx as _jsx } from "react/jsx-runtime";
import { selectActiveLang } from 'features/common';
import { useAppSelector } from 'features';
import { TogglePickerButton } from '../../TogglePickerButton';
import scss from './LanguagePickerBtn.module.scss';
export const LanguagePickerBtn = () => {
    const activeLanguageCode = useAppSelector(selectActiveLang);
    return (_jsx(TogglePickerButton, Object.assign({ className: scss.languagePickerBtn, title: 'Select language' }, { children: activeLanguageCode })));
};
